var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-xs-12" },
          [
            _c("k-table", {
              ref: "listaVendedores",
              attrs: {
                createButton: _vm.puede_crear_vendedor,
                editButton: _vm.puede_editar_vendedor,
                deleteButton: _vm.puede_eliminar_vendedor,
                path: _vm.path,
                columns: [
                  {
                    display: "Código",
                    value: "codigo"
                  },
                  {
                    display: "Nombre/Descripción",
                    value: "descripcion"
                  },
                  {
                    display: "Identificación",
                    value: "numero_identificacion"
                  },
                  {
                    display: "Dirección",
                    value: "direccion"
                  },
                  {
                    display: "Teléfonos",
                    value: "telefonos"
                  },
                  {
                    display: "Correos",
                    value: "correos"
                  },
                  {
                    display: "Creador",
                    value: "creador.nombre"
                  },
                  {
                    display: "Creación",
                    value: "created_at"
                  },
                  {
                    display: "Modificador",
                    value: "modificador.nombre"
                  },
                  {
                    display: "Modificación",
                    value: "updated_at"
                  }
                ]
              },
              on: {
                crear: _vm.crear,
                editar: _vm.editar,
                eliminar: _vm.eliminar
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            name: "vendedor",
            height: "auto",
            width: "70%",
            scrollable: "",
            adaptive: "",
            resizable: "",
            reset: ""
          }
        },
        [
          _c("vendedor", {
            ref: "vendedor",
            on: { cancelar: _vm.cancelar, saved: _vm.vendedorSaved },
            model: {
              value: _vm.selectedVendedor,
              callback: function($$v) {
                _vm.selectedVendedor = $$v
              },
              expression: "selectedVendedor"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__header" }, [
      _c("div", { staticClass: "layout__title" }, [
        _c("h3", [_vm._v("Vendedores")])
      ])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3660eb63", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3660eb63","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/vendedores/ListaVendedores.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3660eb63","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/vendedores/ListaVendedores.vue
// module chunks = 0